export default "__VITE_ASSET__Ba1wFBk1__"